/**
 * Created by Angelika on 26.10.2017.
 */
import React, {Component} from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';

class PreviewTopMenu extends Component {

    render() {
        const {activeChannel, onClosePreviewClick} = this.props;
        return (
            <div className="top-menu">
                <div className="menu">
                    <div className="wrapper">
                        <div className="title">{activeChannel.name}</div>
                        <div className="right">
                            <Link to={`/channels/${activeChannel.channelID}`}><div className="menu-item back">&nbsp;</div></Link>
                            <div className="menu-item close" onClick={onClosePreviewClick}>&nbsp;</div>
                        </div>
                        <div className="clearfx"></div>
                    </div>
                </div>
            </div>
        )
    }
}

PreviewTopMenu.propTypes = {
    activeChannel: PropTypes.object.isRequired,
    onClosePreviewClick: PropTypes.func.isRequired
};

export default PreviewTopMenu;


// WEBPACK FOOTER //
// ./src/components/PreviewTopMenu.js